module.exports = __webpack_public_path__ + "images/emoji/airplane.46c37d8a9f729fa93939.png";